import React, { Component } from 'react'
import Dropdown from '../components/Dropdown'
import "../../node_modules/video-react/dist/video-react.css";
import Graphs from '../components/Dashboard_Graphs'
import PieChart from '../components/Dashboard_charts'
import Tables from '../components/Dashboard_table'
import ReviewPanel from '../components/review_panel'
import { getClassNames } from '../components/UserFunctions'
import PropTypes from 'prop-types';

class Dashboard extends Component {

  state = {
    runid:[],
    benchid:[],
    sceneid:[],
    tagid:[],
    classes:"",
  }


  onDropdownSelect = (runid,benchid,sceneid,tagid) => {
        this.setState({
          runid:runid,
          benchid: benchid,
          sceneid: sceneid,
          tagid: tagid
        });
        var runid_json = { run_id: runid}
        getClassNames(runid_json).then(res => {
          // console.log(res)
          if (res !== undefined) {
            this.setState({
              classes: res.data["classes"]
            })
          }
        }
        )
  }

  componentDidMount(){
    // console.log(this.props)

    if(this.props.location.totalData !== undefined){
      this.setState({
        runid:this.props.location.totalData.test_run_id,
        benchid: this.props.location.totalData.bench_id,
        sceneid: this.props.location.totalData.scenario_group_id,
        tagid: this.props.location.totalData.tag_name
      });
      // console.log(this.props.location.totalData)
      var runid_json = { run_id: this.props.location.totalData.test_run_id}
      getClassNames(runid_json).then(res => {
        if (res !== undefined) {
          this.setState({
            classes: res["classes"]
          })
        }
      }
      )
    }
    
  }

  UNSAFE_componentWillReceiveProps(newProps){
    if(newProps.location.runid !== undefined){
      this.setState({
        runid:newProps.location.runid
        
      });
    }
    var runid_json = { run_id: newProps.location.runid }
    getClassNames(runid_json).then(res => {
      if (res !== undefined) {
        this.setState({
          classes: res["classes"]
        })
      }
    }
    )
  }
//  componentWillReceiveProps(newProps){
//    if(newProps.location.runid !== undefined){
//      this.setState({
//        runid:newProps.location.runid
//
//      });
//    }
//    var runid_json = { run_id: newProps.location.runid }
//    getClassNames(runid_json).then(res => {
//      if (res !== undefined) {
//        this.setState({
//          classes: res["classes"]
//        })
//      }
//    }
//    )
//  }

  render() {
    return (
      <div data-test = 'containerDashboardComponent'>
        <div className="row">
          &nbsp;
        </div>
        <div className="row">
          <div className="col-lg-9">
            <div className="card">
              <div className="card-header" style={{ backgroundColor: "#757AF7", fontSize: "21px" }}>
                  <div>
                       &nbsp; <span style={{ color: "white" }}>KPI Dashboard</span>
                  </div>
              </div>
              <div className="card-body">
                <div className="col-lg-12">
                  <Dropdown onDropdownSelect={this.onDropdownSelect}/>
                  <div className="row" style={{paddingTop:20}}>
                      <div className="col-lg-12">
                        <Graphs run_id={this.state.runid} level="3"/>
                      </div>
                  </div>
                </div>
              </div>
            </div>

            <Tables run_id={this.state.runid} level="3"/>

          </div>
          <div className="col-lg-3">
            <div className ="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-header" style={{ backgroundColor: "#757AF7", fontSize: "21px" }}>
                    <div>
                      <font color="white">&nbsp;Last Run Report</font>
                    </div>
                    <div>
                      <font color="white" size="3">Classes: {this.state.classes}</font>
                    </div>
                  </div>
                  <div className="card-body" >
                    <PieChart run_id={this.state.runid} level="3"/>
                  </div>
                </div>
              </div>
            </div>
            <div>
              &nbsp;
            </div>
            <div className ="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-header" style={{ backgroundColor: "#757AF7", fontSize: "21px" }}>
                    <div>
                      <font color="white">&nbsp;Review Panel</font>
                    </div>
                  </div>
                  <div className="card-body" >
                    <ReviewPanel run_id={this.state.runid}/>
                  </div>
                </div>
              </div>
            </div>
            <div style={{marginTop : "20px"}}>
            <button className="btn" style={{width : "100%"}}>
             Download Report
            </button>
            </div>
          </div>
        </div>
      </div>

    )
  }
}
Dashboard.propTypes={
location:PropTypes.string,
//testRunStatus:PropTypes.string,
//currentPage:PropTypes.string,
//pages:PropTypes.string,
}
Dashboard.defaultProps= {
location:[],
//testRunStatus:[],
//currentPage:[],
//pages:[],
}

export default Dashboard
